import BreadCrumb from '../../components/BreadCrumb/BreadCrumb'
import Meta from '../../components/Meta/Meta'
import React, { useContext, useState, useEffect } from 'react'
import { DataContext } from '../../components/Context/Context'
import formatCurrency from '../../components/Util/Util';
import WishListEmpty from '../../components/Wishlist/WishListEmpty';
import ConfirmModal from '../../components/ConfirmModal/ConfirmModal';

const Wishlist = () => {
    const value = useContext(DataContext);
    const [wish, setWish] = value.wish;
    const removeWishProduct = value.removeWishProduct;
    const addCart = value.addCart;

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [productIdtoDel, setProductIdtoDel] = useState('')

    const onOpenConfirmModal = (productId) => {
        console.log(productId)
        setProductIdtoDel(productId)
        setShowConfirmModal(true)
    }

    const deleteProduct = () => {
        console.log('delete product', productIdtoDel);
        removeWishProduct(productIdtoDel)
        setProductIdtoDel('')
        setShowConfirmModal(false);
    }

    const cancelDeleteProduct = () => {
        console.log('cancel delete product')
        setProductIdtoDel('')
        setShowConfirmModal(false)
    }

    if (wish.length === 0) {
        return (
            <WishListEmpty />
        )
    }
    return (
        <>
            <ConfirmModal
                onConfirm={deleteProduct}
                onCancel={cancelDeleteProduct}
                show={showConfirmModal}
            />
            <div className="marginTop">
                <Meta title={'  محصولات مورده علاقه'} />
                <BreadCrumb title=" محصولات مورده علاقه " />

                <div className="pb-5">
                    <div className="container-xxl">
                        <div className="row">
                            {
                                wish.map(product => (

                                    <div className="col-12 col-xs-6 col-lg-3 p-3 p-lg-2 " key={product._id}>
                                        <div className="wishlist-card position-relative border rounded p-3 ">
                                            <i className="bi bi-x-circle position-absolute cross h5" onClick={() => onOpenConfirmModal(product._id)}></i>
                                            <div className="wishlist-card-image p-2">
                                                <img className='img-fluid my-2 bdrs20 shadow-sec' src={product.images[0]} />
                                                <div className='pt-2 text-center'>
                                                    <h5 className="title">  {product.name} </h5>
                                                    <h5 className="fs13 py-2 lh-base">
                                                        {product.fullName}
                                                    </h5>
                                                    <div className="row">
                                                        <h6 className="text-danger"> {formatCurrency(product.price)} </h6>
                                                        <button type="button" rel="tooltip" className="btn btn-warning p-2 border-0 mt-3" onClick={() => addCart(product._id)}>
                                                            <span className='fs14'>افزودن به سبد خرید</span>
                                                            <i className="bi bi-cart-check-fill ps-3 h5"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Wishlist